import React from 'react';
import {Alert, AlertTitle, Box} from '@customink/pigment-react';

export default function PageErrorFallback() {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '50vh',
        width: '100%'
      }}>
      <Alert severity="error" sx={{margin: '0 auto'}}>
        <AlertTitle>An error occurred while loading this page</AlertTitle>
        Please try again later or contact support if the problem persists.
      </Alert>
    </Box>
  );
}
